<template>
  <div class="page-home text-center pt-5 pr-3 pb-3 pl-3">

    <div class="mb-5 d-block logo">
      <img src="images/full-logo.png" alt="logo" style="max-width: 100%; width: 300px"/>
    </div>

    <div class="user-info" style="margin-bottom: 30px;">
      <div class="fullname">{{ $t("Your TranS ID") }}</div>
      <div class="trans-id">{{ userInfo.transId }}</div>
    </div>

    <div class="alert alert-danger" style="max-width: 600px; margin: 0 auto;">
      Bạn cần tải <a href="https://zoom.us/download#client_4meeting" target="_blank" style="color: blue !important;">Zoom Meetings</a> trước khi tiến hành mở/tham gia phòng họp/học
    </div>

    <div class="buttons">
      <MainButton v-for="(button, key) in buttons" :key="key" :data="button" @click="buttonClicked"/>
    </div>

    <PanelLoading :show="loading" :message="loadingMessage"/>
    <MeetingSchedulePicker ref="meetingSchedulePicker" @select="startMeetingBySchedule"/>
    <ChangePasswordModal ref="changePasswordModal"/>
    <NotificationsModal ref="notificationsModal"/>
    <UtilitiesModal ref="utilitiesModal"/>
    <SendInviteRequestModal ref="sendInviteRequestModal"/>
    <JoinRequestsModal ref="joinRequestsModal" />
  </div>
</template>

<script>
import meetingService from "../services/meeting_service";
import dialogHelper from "../helpers/dialog_helper";
import appHelper from "../helpers/app_helper";
import authenticateService from "../services/authenticate_service";
import SendInviteRequestModal from "../components/SendInviteRequestModal";
import MainButton from "../components/MainButton";
import MeetingSchedulePicker from "../components/MeetingSchedulePicker";
import ChangePasswordModal from "../components/ChangePasswordModal";
import NotificationsModal from "../components/NotificationsModal";
import UtilitiesModal from "../components/UtilitiesModal";
import JoinRequestsModal from "../components/JoinRequestsModal";

export default {
  name: 'Home',
  components: {
    SendInviteRequestModal,
    MainButton, MeetingSchedulePicker, ChangePasswordModal, NotificationsModal, UtilitiesModal,JoinRequestsModal},
  data: function () {
    return {
      loading: true,
      loadingMessage: "Loading...",
      buttons: [],
      userInfo: {
        transId: ""
      }
    }
  },
  methods: {
    buttonClicked: function (data) {
      if (data && data.key) {
        switch (data.key) {
          case "EnterRoom":
            this.startMeeting();
            break;

          case "JoinRoom":
            this.$router.push({name: 'JoinMeeting'});
            break;

          case "Notifications":
            this.$refs.notificationsModal.open();
            break;

          case "Utilities":
            this.$refs.utilitiesModal.open();
            break;

          case "SendInviteRequest":
            this.$refs.sendInviteRequestModal.open();
            break;

          case "JoinRequests":
            this.$refs.joinRequestsModal.open();
            break

          case "ChangePassword":
            this.$refs.changePasswordModal.open();
            break;

          case "SignOut":
            this.signOut();
            break;

          case "CloseApp":
            this.closeApp();
            break;
        }
      }
    },
    startMeeting: async function () {
      if (this.loading)
        return;

      this.loadingMessage = "Connecting to meeting room...";
      this.loading = true;
      const response = await meetingService.initStartMeeting();
      if (!response) {
        this.loading = false;
        return;
      }

      if (!response.startsWith("OK|")) {
        this.loading = false;
        dialogHelper.alert(response, "error");
        return;
      }

      const schedules = JSON.parse(response.substr(3));
      if (schedules.length > 1) {
        this.loading = false;
        this.$refs.meetingSchedulePicker.open(schedules);
      } else
        await this.startMeetingBySchedule(schedules[0]);
    },
    startMeetingBySchedule: async function (schedule) {
      if (schedule == null) {
        this.loading = false;
        dialogHelper.alert("Meeting schedule not found", "error");
        return;
      }

      this.loading = true;
      const response = await meetingService.startMeeting({
        scheduleId: schedule.ScheduleID
      });

      this.loading = false;
      if (!response) return;

      if (!response.startsWith("OK|")) {
        this.loading = false;
        dialogHelper.alert(response, "error");
        return;
      }

      const data = JSON.parse(response.split('|')[1]);
      let isRunning = await appHelper.isMeetingOpening();
      if (isRunning == null) {
        dialogHelper.alert("Your device is not support virtual meeting.", "warning");
        return;
      }

      if (isRunning) {
        dialogHelper.alert("You are already in another meeting, please leave meeting before enter this meeting.", "warning");
        return;
      }

      const result = await appHelper.openMeeting(data, 'start');
      if (result !== 0 && isNaN(result)) {
        dialogHelper.alert(result, "error");
        return;
      }
    },
    async signOut() {
      const result = await dialogHelper.confirm("Are you sure to sign out?");
      if (!result)
        return;

      await this.$store.dispatch("setUserInfo", null);
      await appHelper.setSetting("loginInfo", null);
      await this.$router.push({name: 'Main'});
    },
    async closeApp() {
      const result = await dialogHelper.confirm("Are you sure to close application?");
      if (!result)
        return;

      await appHelper.closeApp()
    },
  },
  beforeCreate() {
    this.setTitle();
  },
  async created() {
    this.userInfo = this.$store.getters.userInfo;
    let buttons = this.$store.getters.mainButtons;
    let keys = Object.keys(buttons);
    this.buttons = [{
      key: "EnterRoom",
      name: keys.includes("EnterRoom") ? buttons["EnterRoom"] : this.$t("Host"),
      icon: "images/ico-start-meeting.png"
    }, {
      key: "JoinRoom",
      name: keys.includes("JoinRoom") ? buttons["JoinRoom"] : this.$t("Join room"),
      icon: "images/ico-join-meeting.png"
    }, {
      key: "Notifications",
      name: this.$t("Notifications"),
      icon: "images/ico-notifications.png",
      number: 0
    }, {
      key: "Utilities",
      name: this.$t("Utilities"),
      icon: "images/ico-cogs.png"
    }, {
      key: "SendInviteRequest",
      name: this.$t("Send invite request"),
      icon: "images/ico-out-box.png"
    }, {
      key: "JoinRequests",
      name: this.$t("Join meeting requests"),
      icon: "images/ico-in-box.png",
      number: 0
    }, {
      key: "ChangePassword",
      name: this.$t("Change password"),
      icon: "images/ico-fill-lock.png"
    }, {
      key: "SignOut",
      name: this.$t("Sign out"),
      icon: "images/ico-sign-out.png"
    }];
    // , {
    //   key: "CloseApp",
    //   name: this.$t("Close application"),
    //   icon: "images/ico-power-off.png"
    // }

    const response = await authenticateService.home();
    this.loading = false;

    if (response && response.startsWith("OK|")) {
      let data = JSON.parse(response.substr(3));
      let button = this.buttons.find(x => x.key === "Notifications");
      if (button) button.number = data.TotalNotifications;

      button = this.buttons.find(x => x.key === "JoinRequests");
      if (button) button.number = data.TotalJoinRequests;
    }
  }
}
</script>
